import type { ReviewPackTemplate } from '../review-pack';

export const MONTHLY_BUSINESS_REVIEW_TEMPLATE = {
  templateId: 'logistics-mbr-default',
  cadence: 'monthly_business_review',
  industryProfileId: 'logistics-default',
  audience: 'finance_leadership',
  sections: [
    {
      sectionId: 'partner_opening',
      title: 'Partner opening: where leadership attention belongs',
      purpose: 'Open the MBR with the brief lede, coverage badge, and decision agenda.',
      required: true,
      sourceAnswerFamily: 'exec_brief_v2',
      plannerArchetype: 'review_pack',
      sourceCompositionPath: 'apps/api/src/ask-helix/ask-helix.exec-brief-v2.ts',
      requiredInputs: ['brief_live_providers', 'decision_console_read_model'],
      freshnessRequirement: { maxAgeHours: 48, staleBehavior: 'block' },
      proofRequirement: 'proof_ref_required',
      actionAffordances: ['annotate', 'share_snapshot'],
    },
    {
      sectionId: 'month_variance_bridge',
      title: 'Month variance bridge',
      purpose: 'Preserve the variance decomposition summary for the promoted month.',
      required: true,
      sourceAnswerFamily: 'variance_decomposition',
      plannerArchetype: 'review_pack',
      sourceCompositionPath:
        'apps/api/src/ask-helix/variance/variance-decomposition-composition.ts',
      requiredInputs: ['promoted_month_metric_facts', 'variance_decomposition_v1'],
      freshnessRequirement: { maxAgeHours: 72, staleBehavior: 'block' },
      proofRequirement: 'proof_ref_required',
      actionAffordances: ['annotate', 'share_snapshot'],
    },
    {
      sectionId: 'drift_intervention_docket',
      title: 'Drift status and intervention docket',
      purpose:
        'Show current drift status and the docket of recovery actions that need adoption.',
      required: true,
      sourceAnswerFamily: 'drift_realization',
      plannerArchetype: 'review_pack',
      sourceCompositionPath:
        'apps/api/src/ask-helix/drift/drift-realization-intent.ts',
      requiredInputs: ['decision_console_read_model', 'drift_realization_read_model'],
      freshnessRequirement: { maxAgeHours: 72, staleBehavior: 'block' },
      proofRequirement: 'proof_ref_required',
      actionAffordances: ['annotate', 'adopt_into_monitoring', 'share_snapshot'],
    },
  ],
  freshnessPolicy: { generatedAtRequired: true, sectionAsOfRequired: true },
  requiredPermissions: ['ask_helix:read', 'decision_agent:read'],
  sharePolicy: 'immutable_snapshot',
  decisionLedgerCadence: 'monthly',
} as const satisfies ReviewPackTemplate;
